import { render } from "./OnboardingTour.vue?vue&type=template&id=3624fa62&scoped=true"
import script from "./OnboardingTour.vue?vue&type=script&lang=js"
export * from "./OnboardingTour.vue?vue&type=script&lang=js"

import "./OnboardingTour.vue?vue&type=style&index=0&id=3624fa62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3624fa62"]])

export default __exports__